module.exports = __webpack_public_path__ + "img/PEUGEOT.b9a51a8.jpg";